import ApiConstant from "../../../constants/api.constants";
import ConsoleType from "../../../constants/console-type.constant";
import Helpers from "../../../utils/helpers";
import api from "../../api";
import SampleData from "./stable_data/sample_data.json";
import SampleEditData from "./stable_data/sample_edit_data.json";
import axios from "axios";

//for Survey Overview data
const baseURL = process.env.REACT_APP_SERVER_ENDPOINT_AURA_CAMERA;

//for Emission Overview data
const GetCameraOperatorsData = async () => {
  try {
    const response = await api.get(baseURL + ApiConstant.getCameraOperators);

    if (response && response.data) {
      let filtered_data = response.data;
      filtered_data = filtered_data.filter((val: any) => {
        if (val.isAuraCameraUser == true) {
          return true;
        }
      });
      filtered_data.map((val: any) => {
        val.name = `${val.firstName} ${val.lastName}`;
        const formattedDate = Helpers.convertUTCtoMMDDYYYY(
          val.initial_training_date
        );
        const formattedDateLastDate = Helpers.convertUTCtoMMDDYYYY(
          val.last_training_Date
        );

        val.initial_training_date = formattedDate;
        val.last_training_date = formattedDateLastDate;
      });
      return filtered_data;
    }
  } catch (error: any) {
    return "error";
  }

  // getSurveyOverview
  // return await new Promise((resolve, reject) => {
  //   resolve(SampleData.data);
  // });
};

const AddCameraOperatorsData = async (data: any) => {
  console.log(data);

  // try {
  //   const response = await api.post(
  //     baseURL + ApiConstant.addSiteSummary,
  //     data
  //   );

  //   if (response && response.data) {
  //     return response.data;
  //   }
  // } catch (error:any) {
  //   return "error"
  // }

  return "success";
};

const GetUpdateCameraOperatorsData = async (id: any) => {
  // if no data then return "error"
  try {
    const response = await api.get(
      `${baseURL}${ApiConstant.getbyCameraOperatorId}/${id}`
    );

    if (response && response.data) {
      return response.data;
    }
  } catch (error: any) {
    return "error";
  }

  return SampleEditData.data;
};

const UpdateCameraOperatorsData = async (
  data: any,
  id: any,
  CustomerID: any
) => {
  let Final_SubmitData: any = [];
  Final_SubmitData.InitialDate = Helpers.convertToUTC(data.InitialDate1);
  Final_SubmitData.LastDate = Helpers.convertToUTC(data.LastDate1);
  Final_SubmitData.Comment = data.comment;
  Final_SubmitData.Email = data.email1;
  Final_SubmitData.FirstName = data.firstName;
  Final_SubmitData.LastName = data.lastName;
  Final_SubmitData.IsOGIInitialTraining = data.ogiInitialTraining;
  Final_SubmitData.OperatorCustomJobTitle = data.operatorCustomJobTitle;
  Final_SubmitData.UserID = id;
  Final_SubmitData.CustomerID = CustomerID;

  return "success1";

  try {
    const response = await api.put(
      `${baseURL}${ApiConstant.UpdateCameraOperator}/${id}`,
      Final_SubmitData
    );

    if (response && response.data) {
      return "success";
      return response.data;
    }
  } catch (error: any) {
    return "error";
  }
};

const DeleteCameraOperatorsData = async (id: any) => {
  // SampleEditData
  // return id;
  return "success";

  try {
    const response = await api.delete(
      `${baseURL}${ApiConstant.deleteCameraOperator}/${id}`
    );

    if (response && response.data) {
      return "success";
      return response.data;
    }
  } catch (error: any) {
    return "error";
  }
};

const CameraOperatorsService = {
  GetCameraOperatorsData,
  AddCameraOperatorsData,
  UpdateCameraOperatorsData,
  GetUpdateCameraOperatorsData,
  DeleteCameraOperatorsData,
};

export default CameraOperatorsService;
